import {
  Directive,
  ElementRef,
  inject,
  OnDestroy,
  OnInit,
} from '@angular/core';

@Directive({
  selector: '[horizontalScroll]',
  standalone: true,
  host: {
    '[style.overscroll-behavior]': '"none"',
    '[style.overflow-y]': '"hidden"',
  },
})
export class HorizontalScrollDirective implements OnInit, OnDestroy {
  readonly #element = inject(ElementRef<HTMLElement>);

  #onWheel = (event: WheelEvent): void => {
    this.#element.nativeElement.scrollLeft += event.deltaY;
  };

  ngOnInit(): void {
    this.#element.nativeElement.addEventListener('wheel', this.#onWheel, {
      passive: true,
    });
  }

  ngOnDestroy(): void {
    this.#element.nativeElement.removeEventListener('wheel', this.#onWheel);
  }
}
